import React from 'react';
import { useMediaQuery } from '@mui/material';
import TableHeadContactsMobile from "../components/mobile/contacts/TableHeadContactsMobile";
import TableHeadContacts from "../views/contacts/TableHeadFilter";


const ContactsRouter = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

    return isMobile ? <TableHeadContactsMobile /> : <TableHeadContacts />;
};

export default ContactsRouter;
